import React from 'react';
import { ListSubheader, withStyles } from '@material-ui/core';

const CustomSubheader = withStyles(() => ({
  root: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
    color: '#212328',
    padding: '6px 16px',
  },
}))(ListSubheader);

const CustomMenuItemComponent = ({ item }) => (
  <CustomSubheader key={item}>{item.label}</CustomSubheader>
);

export default CustomMenuItemComponent;
